import RequestBuilder from "../RequestBuilder"
import {Method} from "../enum/Method"
import {AnyCustomModelOptions} from "../json/CustomModelOptionsJson"
import {AnyCustomModelJson} from "../json/CustomModelJson"
import {PagedCustomModelJson} from "../json/PagedResponseJson"
import {CustomModelPrecheckJson} from "../json/CustomModelPrecheckJson"
import {ModelPlatform} from "../enum/ModelPlatform"
import {CompletionOptionsJson} from "../json/CompletionOptionsJson"
import {CompletionRequestJson} from "../json/CompletionRequestJson"
import {EndpointJson} from "../json/EndpointJson"
import {EndpointStatus} from "../enum/EndpointStatus"

export interface CustomModelNameJson {
    name: string
}

export class CustomModelRequests {
    static create(projectId: string, name: string, options: AnyCustomModelOptions): Promise<AnyCustomModelJson> {
        return new RequestBuilder(Method.Post, `projects/${projectId}/custom-models`)
            .withJson({name, options})
            .buildAndSend()
    }

    static list(projectId: string, templateId?: string, platform?: ModelPlatform, completedOnly?: boolean): Promise<PagedCustomModelJson> {
        const queryParams = new URLSearchParams()
        if (templateId) queryParams.append("templateId", templateId)
        if (platform) queryParams.append("platform", platform)
        if (completedOnly) queryParams.append("completed", "true")

        return new RequestBuilder(Method.Get, `projects/${projectId}/custom-models?${queryParams.toString()}`)
            .buildAndSend()
    }

    static get(customModelId: string): Promise<AnyCustomModelJson> {
        return new RequestBuilder(Method.Get, `custom-models/${customModelId}`)
            .buildAndSend()
    }

    static precheck(projectId: string, name: string, options: AnyCustomModelOptions): Promise<CustomModelPrecheckJson> {
        return new RequestBuilder(Method.Post, `projects/${projectId}/custom-models/precheck`)
            .withJson({name, options})
            .buildAndSend()
    }

    static delete(projectId: string, customModelId: string, deleteFromPlatform: boolean): Promise<void> {
        return new RequestBuilder(Method.Delete, `projects/${projectId}/custom-models/${customModelId}`)
            .withJson({deleteFromPlatform})
            .buildAndSend()
    }

    static getName(): Promise<CustomModelNameJson> {
        return new RequestBuilder(Method.Get, `custom-models/names`).buildAndSend()
    }

    static complete(customModelId: string, inputs: Record<string, string>, options: CompletionOptionsJson): Promise<CompletionRequestJson> {
        return new RequestBuilder(Method.Post, `custom-models/${customModelId}/completions`)
            .withJson({inputs, options})
            .buildAndSend()
    }

    static endpoints(customModelId: string): Promise<EndpointJson[]> {
        return new RequestBuilder(Method.Get, `custom-models/${customModelId}/endpoints`)
            .buildAndSend()
    }

    static projectEndpointStatuses(projectId: string): Promise<Record<string, EndpointStatus>> {
        return new RequestBuilder(Method.Get, `projects/${projectId}/custom-model-endpoints`)
            .buildAndSend()
    }
}
